import isInBrowser from '@helpers/is-in-browser'

export default function isApacSite() {
  if (isInBrowser) {
    return !!window.location.href.match(/.co.nz|.com.au|staging-au|go\/apac\//)
  }

  return null
}
